<template>
  <div id="app">
    <v-container fluid grid-list-md>
      <div class="home" v-if="!$vuetify.breakpoint.smAndDown">
        <h2>Bem Vindo!</h2>

        <div class="background-home">
          <img :src="`${basePath}images/home_background.png`" alt="illis">
          <div class="home-buttons">
            <a target="_blank" href="https://www.linkedin.com/company/illis-solu%C3%A7%C3%B5es/" class="linkedin">
              <img :src="`${basePath}images/linkedin.png`" alt="Linkedin">
            </a>
            <a target="_blank" href="https://www.instagram.com/illissolucoes/" class="instagram">
              <img :src="`${basePath}images/instagram.png`" alt="Instagram">
            </a>
            <a target="_blank" href="https://www.facebook.com/illissolucoes/" class="facebook">
              <img :src="`${basePath}images/facebook.png`" alt="Facebook">
            </a>
            <a target="_blank" href="https://www.youtube.com/channel/UChnglEU6grDpO2lHvrmyG0Q?view_as=subscriber" class="youtube">
              <img :src="`${basePath}images/youtube.png`" alt="Youtube">
            </a>
          </div>
        </div>
      </div>
      <div v-else>
        <div style="color: #176f8f" class="headline">Movimentações</div>        
        <div class="buttons-mobile">
          <v-btn style="height: 100%" top class="py-3" dark color="primary" to="/tasks">
            <div style="display: flex; flex-direction: column; align-items: center;">
              <v-icon large>list</v-icon>
              <span class="mt-1">Tarefas</span>
            </div>
          </v-btn>

          <v-btn style="height: 100%" top class="py-3" dark color="primary" to="/calendar">
            <div style="display: flex; flex-direction: column; align-items: center;">
              <v-icon large>calendar_today</v-icon>
              <span class="mt-1">Agenda</span>
            </div>
          </v-btn>

          <v-btn style="height: 100%" top class="py-3" dark color="primary" to="/files">
            <div style="display: flex; flex-direction: column; align-items: center;">
              <v-icon large>folder</v-icon>
              <span class="mt-1">Arquivos</span>
            </div>
          </v-btn>
        </div>

        <div style="color: #176f8f; margin-top: 16px;" class="headline">Cadastros</div>
        <div class="buttons-mobile">
          
          <v-btn style="height: 100%" top class="py-3" dark color="primary" @click="openCompanyUserDialog()">
            <div style="display: flex; flex-direction: column; align-items: center;">
              <v-icon large>portrait</v-icon>
              <span class="mt-1">Convidar</span>
              <span class="mt-1">Usuários</span>
            </div>
          </v-btn>

          <v-btn style="height: 100%" top class="py-3" dark color="primary" to="/teams">
            <div style="display: flex; flex-direction: column; align-items: center;">
              <v-icon large>group</v-icon>
              <span class="mt-1">Equipes</span>
            </div>
          </v-btn>


          <v-btn style="height: 100%" top class="py-3" dark color="primary" to="/tasktemplates">
            <div style="display: flex; flex-direction: column; align-items: center;">
              <v-icon large>file_copy</v-icon>
              <span class="mt-1">Modelos</span>
              <span class="mt-1">de Tarefa</span>
            </div>
          </v-btn>
        </div>
        
        <div class="buttons-mobile" style="margin-top: 10px">
          <v-btn style="height: 100%" top class="py-3" dark color="primary" to="/connections">
            <div style="display: flex; flex-direction: column; align-items: center;">
              <v-icon large>group_work</v-icon>
              <span class="mt-1">Parceiros</span>
              <span v-if="connectionInvites > 0" class="badge-mobile-home">{{connectionInvites}}</span>
            </div>
          </v-btn>

          <v-btn style="height: 100%" top class="py-3" dark color="primary" to="/accesses">
            <div style="display: flex; flex-direction: column; align-items: center;">
              <v-icon large>lock</v-icon>
              <span class="mt-1">Acessos</span>
            </div>
          </v-btn>
        </div>

        <div style="color: #176f8f; margin-top: 16px;" class="headline">Análises</div>
        <div class="buttons-mobile">
          <v-btn style="height: 100%" top class="py-3" dark color="primary" to="/dashboard_movement">
            <div style="display: flex; flex-direction: column; align-items: center;">
              <v-icon large>dashboard</v-icon>
              <span class="mt-1">Dashboard</span>
            </div>
          </v-btn>

          <v-btn style="height: 100%" top class="py-3" dark color="primary" to="/report">
            <div style="display: flex; flex-direction: column; align-items: center;">
              <v-icon large>library_books</v-icon>
              <span class="mt-1">Relatórios</span>
            </div>
          </v-btn>
        </div>

        <div class="buttons-mobile">
          <div style="margin-top: 10px; width: 100%;">
            <v-btn flat to="upgrade" id="upgrade">
              <img src="https://img.icons8.com/color/48/000000/fairytale.png" height="30px"> &nbsp; Fazer Upgrade
            </v-btn>
          </div>
        </div>

      </div>
    </v-container>
  </div>
</template>
<style scoped>
  .home{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
  }

  .home h2{
    font-size: 3em;
  }

  .home .background-home{
    position: relative;
  }

  .home .background-home img{
    transition: 1s;
  }

  .home .background-home .home-buttons{
    position: absolute;
    top: 180px;
    right: 190px;
    display: flex;
    flex-direction: column;
    transition: 1s;
  }

  .home .background-home .home-buttons img{
    width: 60px;
    cursor: pointer;
    transition: 1s;
  }

  .home .background-home .home-buttons .linkedin img:hover,
  .home .background-home .home-buttons .instagram img:hover,
  .home .background-home .home-buttons .facebook img:hover,
  .home .background-home .home-buttons .youtube img:hover{
    width: 70px;
    transition: 1s;
  }

  .buttons-mobile{
    display: flex;
    align-items: initial;
    justify-content: start;
  }

  #upgrade {
    margin: 0;
    width: 100%;
    padding: 20px;
    color: #ffbb25 !important;
    text-transform: capitalize;
    border-radius: 0;
  }

  .badge-mobile-home{
    position: absolute;
    color: #00acc2;
    display: inline-block;
    background: #fff;
    padding: 0 6px;
    border-radius: 50%;
    top: -10px;
    right: 0;
  }

  @media screen and (max-width: 900px) {
    .home .background-home img{
      width: 500px;
    }

    .home .background-home .home-buttons{
      top: 115px;
      right: 120px;
    }

    .home .background-home .home-buttons img{
      width: 35px;
    }

    .home .background-home .home-buttons .linkedin img:hover,
    .home .background-home .home-buttons .instagram img:hover,
    .home .background-home .home-buttons .facebook img:hover,
    .home .background-home .home-buttons .youtube img:hover{
      width: 40px;
    }
  }

  @media screen and (max-width: 550px) {
    .home .background-home img{
      width: 400px;
    }

    .home .background-home .home-buttons{
      top: 95px;
      right: 95px;
    }

    .home .background-home .home-buttons img{
      width: 25px;
    }

    .home .background-home .home-buttons .linkedin img:hover,
    .home .background-home .home-buttons .instagram img:hover,
    .home .background-home .home-buttons .facebook img:hover,
    .home .background-home .home-buttons .youtube img:hover{
      width: 35px;
    }
  }
</style>
<script>
  export default {
    props: [
      'connectionInvites'
    ],
    data: () => ({
      videoId: 'sE3ZlBiTH8Y',
      news: {
        articles: []
      },
      basePath: process.env.API
    }),
    created () {
      var url = 'http://newsapi.org/v2/top-headlines?' + 'country=BR&' + 'apiKey=415af34c9bcf4341a5a27fcc41e8a160'
      this.$http.get(url).then(res => {
        this.news = res.body
      })
    },
    methods: {
      playVideo () {
        this.player.playVideo()
      },
      openCompanyUserDialog () {
        this.$emit('callIn', 'openCompanyUserDialog')
      }
    },
    computed: {
      player () {
        return this.$refs.youtube.player
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Home.vue